import { useState } from "react";
import Text from "../../../../components/ui/Text";
import Button from "../ui/Button";

interface Props {
  className?: string;
  title?: string;
  description?: string;
  submitTitle?: string;
  onClose: () => void;
  onAdd?: () => void;
}

const AddPlayerModal = ({
  className = "",
  title = "Adding Player",
  description = "Stay cool",
  submitTitle = "Add",
  onClose,
  onAdd = () => {},
}: Props) => {
  const [value, setValue] = useState<string>("");

  return (
    <div
      className={`bg-gradient-to-b from-[#494864] to-[#161820] p-5 rounded-md  ${className}`}
    >
      <button
        title="Close"
        className="text-red-500 text-sm absolute top-2 right-2 cursor-pointer"
        onClick={onClose}
      >
        X
      </button>
      <Text
        size="sm"
        className="!font-semibold text-[#BEB9FF] text-center leading-[105%]"
      >
        {title}
      </Text>
      <Text size="xxs" className="text-center text-[#BEB9FF8C]/45">
        {description}
      </Text>

      <input
        type="text"
        className="my-2 bg-[#161820] rounded-md p-2 py-[6px] w-full text-sm placeholder:text-[13px] placeholder:text-white/30 border-0 outline-0 text-white"
        value={value}
        placeholder="Enter player name"
        onChange={(e) => setValue(e.target.value)}
      />

      <Button
        variant="blue"
        onClick={() => {
          onAdd(); // provide some data
        }}
      >
        <Text size="xxs" className="text-white">
          {submitTitle}
        </Text>
      </Button>
    </div>
  );
};

export default AddPlayerModal;
